module.exports = __webpack_public_path__ + "static/media/todo.640fc4ca.PNG";